// extracted by mini-css-extract-plugin
module.exports = {"userList":"userAdmin_userList__2Iw8N"};